import { DeliveryMethod } from "@modules/order/constants";

import { CURRENCIES, DeliveryTypeIds, DeliveryTypes, EVENTS, STEPS } from "./constants";
import { TEcommerceEvent, TGTMData } from "./types";

const gtmEventEcommerceData = (gtmData: TGTMData, step: number | undefined, event: string): TEcommerceEvent => {
  const ecommerceData: TEcommerceEvent = {
    ecommerce: {
      currencyCode: CURRENCIES.EUR,
    },
    event,
  };

  const getDeliveryMethod = () => {
    const { deliveryMethod } = gtmData;
    switch (deliveryMethod) {
      case DeliveryMethod.DoorToDoor:
        return { id: DeliveryTypeIds.TWO, name: DeliveryTypes.DoorToDoor };
      case DeliveryMethod.PudoToPudo:
        return { id: DeliveryTypeIds.ONE, name: DeliveryTypes.PudoToPudo };
      case DeliveryMethod.PudoToDoor:
        return { id: DeliveryTypeIds.FOUR, name: DeliveryTypes.PudoToDoor };
      case DeliveryMethod.DoorToPudo:
        return { id: DeliveryTypeIds.THREE, name: DeliveryTypes.DoorToPudo };
      default:
        return { id: DeliveryTypeIds.ONE, name: DeliveryTypes.PudoToPudo };
    }
  };

  const senderCountry = gtmData.countryFrom;
  const receiverCountry = gtmData.countryTo;
  const deliveryMethod = getDeliveryMethod();
  const { price } = gtmData;
  const variant = gtmData.packageSize;

  if (event === EVENTS.CHECKOUT) {
    ecommerceData.ecommerce.checkout = {
      actionField: { step },
      products: [
        {
          name: deliveryMethod.name,
          id: deliveryMethod.id,
          price,
          category: `${senderCountry}/${receiverCountry}`,
          variant: variant || "",
          quantity: 1,
        },
      ],
    };

    if (step === STEPS.FOUR && gtmData.option && gtmData.option !== "") {
      ecommerceData.ecommerce.checkout.actionField.option = gtmData.option;
    }
  }

  if (event === EVENTS.PURCHASE) {
    ecommerceData.ecommerce.purchase = {
      actionField: { id: gtmData.identification, revenue: price },
      products: [
        {
          name: deliveryMethod.name,
          id: deliveryMethod.id,
          price,
          category: `${senderCountry}/${receiverCountry}`,
          variant: variant || "",
          quantity: 1,
        },
      ],
    };

    if (gtmData.promoCode) {
      ecommerceData.ecommerce.purchase.actionField.coupon = gtmData.promoCode;
    }
  }

  return ecommerceData;
};

export default gtmEventEcommerceData;
